// Inspired from https://davidwalsh.name/convert-html-stings-dom-nodes
export default function getFragmentFromString(htmlString) {
  return document.createRange().createContextualFragment(htmlString);
}
